/**
 * PULSE Shell Transitions
 * ------------------------------------------------------------
 * Every "screen" is a REAL Shopify URL (homepage, product page,
 * or a Page). This script intercepts same-origin navigation
 * clicks, fetches the real page, and swaps only #MainContent —
 * the persistent header/footer sections never re-render.
 *
 * Progressive enhancement: if fetch/pushState fail, aren't
 * supported, or the request errors, it falls straight back to
 * a normal browser navigation. No link ever stops working.
 */
(function(){
  var MAIN_ID = 'MainContent';
  var body = document.body;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var inFlight = false;

  function isEligible(link){
    if(!link || !link.href) return false;
    if(link.target && link.target !== '' && link.target !== '_self') return false;
    if(link.hasAttribute('download')) return false;
    if(link.dataset && link.dataset.noTransition !== undefined) return false;
    var url;
    try{ url = new URL(link.href, window.location.href); } catch(e){ return false; }
    if(url.origin !== window.location.origin) return false;
    if(/^\/(cart|checkout|account|admin)/.test(url.pathname)) return false;
    if(url.pathname === window.location.pathname && url.hash) return false;
    return true;
  }

  function setActiveNav(url){
    var path = new URL(url, window.location.origin).pathname;
    document.querySelectorAll('[data-nav-link]').forEach(function(el){
      var elPath;
      try{ elPath = new URL(el.href, window.location.origin).pathname; } catch(e){ return; }
      var active = elPath === path;
      el.classList.toggle('is-active', active);
      if(el.hasAttribute('role') && el.getAttribute('role') === 'tab'){
        el.setAttribute('aria-selected', active ? 'true' : 'false');
      }
    });
    body.classList.toggle('not-home', path !== '/');
  }

  function announce(title){
    var el = document.getElementById('PulseRouteAnnouncer');
    if(el) el.textContent = 'Now viewing ' + title;
  }

  function runSweep(){
    var sweep = document.getElementById('PulseSweep');
    if(!sweep || reduceMotion) return;
    sweep.classList.remove('run');
    void sweep.offsetWidth;
    sweep.classList.add('run');
  }

  function closeMobileMenu(){
    var menu = document.getElementById('mobileMenu');
    var toggle = document.getElementById('navToggle');
    if(!menu || !toggle) return;
    menu.classList.remove('active');
    toggle.classList.remove('active');
    toggle.setAttribute('aria-expanded', 'false');
    body.style.overflow = '';
  }

  function swapContent(html, url){
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var incoming = doc.getElementById(MAIN_ID);
    var current = document.getElementById(MAIN_ID);

    if(!incoming || !current){
      window.location.href = url;
      return;
    }

    document.title = doc.title;

    function finish(){
      window.scrollTo({ top:0, behavior:'auto' });
      setActiveNav(url);
      announce(doc.title);
      runSweep();
      inFlight = false;
      window.dispatchEvent(new CustomEvent('pulse:navigated', { detail:{ url:url } }));
    }

    if(reduceMotion){
      current.replaceWith(incoming);
      incoming.classList.add('is-entered');
      finish();
      return;
    }

    current.classList.add('is-leaving');
    setTimeout(function(){
      current.replaceWith(incoming);
      incoming.classList.add('is-entering');
      void incoming.offsetWidth;
      incoming.classList.add('is-entered');
      incoming.classList.remove('is-entering');
      setTimeout(finish, 60);
    }, 260);
  }

  function navigate(url, pushHistory){
    if(inFlight) return;
    inFlight = true;
    fetch(url, { headers: { 'X-Requested-With': 'fetch' } })
      .then(function(res){
        if(!res.ok) throw new Error('Navigation fetch failed: ' + res.status);
        return res.text();
      })
      .then(function(html){
        if(pushHistory) history.pushState({ pulseShell:true }, '', url);
        swapContent(html, url);
      })
      .catch(function(){
        inFlight = false;
        window.location.href = url;
      });
  }

  document.addEventListener('click', function(e){
    var link = e.target.closest('a');
    if(!isEligible(link)) return;
    e.preventDefault();
    closeMobileMenu();
    navigate(link.href, true);
  });

  window.addEventListener('popstate', function(){
    navigate(window.location.href, false);
  });

  var toggle = document.getElementById('navToggle');
  var menu = document.getElementById('mobileMenu');
  if(toggle && menu){
    toggle.addEventListener('click', function(){
      var active = menu.classList.toggle('active');
      toggle.classList.toggle('active', active);
      toggle.setAttribute('aria-expanded', active);
      body.style.overflow = active ? 'hidden' : '';
    });
  }

  setActiveNav(window.location.href);
})();
